<svg width="286" height="200" aria-label="A chart." style="overflow: hidden;">
    <rect x="0" y="0" width="286" height="200" stroke="none" stroke-width="0" fill="#ffffff"></rect>
    <g>
        <rect x="0" y="20" width="286" height="164" stroke="none" stroke-width="0" fill-opacity="0" fill="#ffffff"></rect>
        <g>
            <g>
                <rect x="0" y="183" width="286" height="1" stroke="none" stroke-width="0" fill="#cccccc"></rect>
                <rect x="0" y="142" width="286" height="1" stroke="none" stroke-width="0" fill="#cccccc"></rect>
                <rect x="0" y="102" width="286" height="1" stroke="none" stroke-width="0" fill="#cccccc"></rect>
                <rect x="0" y="61" width="286" height="1" stroke="none" stroke-width="0" fill="#cccccc"></rect>
                <rect x="0" y="20" width="286" height="1" stroke="none" stroke-width="0" fill="#cccccc"></rect>
            </g>
            <g>
                <rect x="4" y="165" width="12" height="18" stroke="none" stroke-width="0" fill="#4374e0"></rect>
                <rect x="75" y="172" width="12" height="11" stroke="none" stroke-width="0" fill="#4374e0"></rect>
                <rect x="17" y="98" width="12" height="85" stroke="none" stroke-width="0" fill="#53a8fb"></rect>
                <rect x="88" y="89" width="12" height="94" stroke="none" stroke-width="0" fill="#53a8fb"></rect>
                <rect x="30" y="123" width="12" height="60" stroke="none" stroke-width="0" fill="#d3362d"></rect>
                <rect x="101" y="111" width="12" height="72" stroke="none" stroke-width="0" fill="#d3362d"></rect>
                <rect x="43" y="83" width="12" height="100" stroke="none" stroke-width="0" fill="#e49307"></rect>
                <rect x="114" y="49" width="12" height="134" stroke="none" stroke-width="0" fill="#e49307"></rect>
                <rect x="56" y="141" width="12" height="42" stroke="none" stroke-width="0" fill="#5f9654"></rect>
                <rect x="127" y="153" width="12" height="30" stroke="none" stroke-width="0" fill="#5f9654"></rect>
            </g>
            <g>
                <rect x="0" y="183" width="286" height="1" stroke="none" stroke-width="0" fill="#333333"></rect>
            </g>
            <g>
                <path d="M36.125,121.70669999999998L107.375,114.2413L178.625,120.256L249.875,123.3041" stroke="#4374e0" stroke-width="2" fill-opacity="1" fill="none"></path>
            </g>
        </g>
    </g>
</svg>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/source/app/controls/components/chart/combo-chart/combo-chart.html